import React, { Fragment } from "react";
import {
  Input,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

const WarehouseInfo = (props) => {
  const { handleMappingChange, warehouse, warehouseHeaders, warehouseFields } =
    props;

  return (
    <form margin="dense" noValidate autoComplete="off">
      <Typography component="h4" style={{ marginBottom: 10 }}>
        Match the headers with an account number
      </Typography>
      <Grid container spacing={2} alignItems="center">
        {warehouseHeaders.length ? (
          warehouseHeaders.map((item, index) => (
            <Fragment key={index + "_headers"}>
              <Grid key={index + "_text_container"} item xs={12} sm={6}>
                <TextField
                  fullWidth
                  key={index + "_text"}
                  size="small"
                  disabled={true}
                  id="outlined-basic"
                  label="Header"
                  variant="outlined"
                  name="accounts"
                  value={item && item}
                />
              </Grid>
              <Grid key={index + "select_container"} item xs={12} sm={6}>
                <Select
                  fullWidth
                  key={index + "select"}
                  name={"select-" + item}
                  input={<Input />}
                  value={(warehouse && warehouse.csv_header_mapping[item]) || ""}
                  onChange={handleMappingChange}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  {warehouseFields.map((item, index) => (
                    <MenuItem
                      key={index + "_" + item}
                      value={item}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Fragment>
          ))
        ) : (
          <Grid item xs={12} sm={12}>
            <Typography component="h4" style={{ marginBottom: 10 }}>
              There are no headers for this warehouse
            </Typography>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default WarehouseInfo;
